export function activeSlide(el: HTMLElement): number {
  const items = Array.from(el.children) as HTMLElement[];
  if (items.length === 0) return 0;

  const max = el.scrollWidth - el.clientWidth;
  if (max <= 1 || el.scrollLeft <= 1) return 0;
  if (el.scrollLeft >= max - 1) return items.length - 1;

  const padLeft = parseFloat(getComputedStyle(el).paddingLeft) || 0;
  const edge = el.getBoundingClientRect().left + padLeft;

  let best = 0;
  let bestDistance = Infinity;
  items.forEach((item, i) => {
    const distance = Math.abs(item.getBoundingClientRect().left - edge);
    if (distance < bestDistance) {
      bestDistance = distance;
      best = i;
    }
  });
  return best;
}

// Arrows land the next or previous item on the scroller's start edge, so a card
// is never left half cut. Some scrollers wrap their items in a single list.
export function scrollToAdjacent(el: HTMLElement, dir: 1 | -1): void {
  const list =
    el.children.length === 1 && el.children[0].children.length > 1
      ? (el.children[0] as HTMLElement)
      : el;
  const items = Array.from(list.children) as HTMLElement[];
  if (items.length === 0) return;

  const pad = parseFloat(getComputedStyle(list).paddingLeft) || 0;
  const origin = el.getBoundingClientRect().left - el.scrollLeft + pad;
  const offsets = items.map((item) => item.getBoundingClientRect().left - origin);
  const current = el.scrollLeft;

  const target =
    dir > 0
      ? offsets.find((offset) => offset > current + 1)
      : [...offsets].reverse().find((offset) => offset < current - 1);
  if (target === undefined) return;

  const max = el.scrollWidth - el.clientWidth;
  el.scrollTo({ left: Math.max(0, Math.min(target, max)), behavior: "smooth" });
}

// Brings one item fully inside its horizontal scroller without moving the page.
export function revealInScroller(el: HTMLElement, item: HTMLElement): void {
  const scroller = el.getBoundingClientRect();
  const rect = item.getBoundingClientRect();
  const gap = 16;
  if (rect.left >= scroller.left && rect.right <= scroller.right) return;

  const delta =
    rect.left < scroller.left ? rect.left - scroller.left - gap : rect.right - scroller.right + gap;
  el.scrollBy({ left: delta, behavior: "smooth" });
}
